// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5e328702","498":"f55d5543","703":"ac859ed9"}[chunkId] + ".chunk.js";
};